import { render, staticRenderFns } from "./discipline.vue?vue&type=template&id=719c385d&scoped=true&"
import script from "./discipline.vue?vue&type=script&lang=js&"
export * from "./discipline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719c385d",
  null
  
)

export default component.exports